if(document.querySelector('.catalogue-section__main-categories')) {
  const mainCategoriesEl = document.querySelector('.catalogue-section__main-categories');
  const subCategoriesEl = document.querySelector('.catalogue-section__subcategories');

  const mainCategoriesArr = mainCategoriesEl.querySelectorAll('.catalogue-section__main-category');
  const subCategoriesArr = subCategoriesEl.querySelectorAll('.catalogue-section__categories');

  mainCategoriesArr.forEach((main, idx) => {
    main.addEventListener('click', (e) => {
      e.preventDefault();

      for (let i = 0; i < subCategoriesArr.length; i++) {
        subCategoriesArr[i].classList.remove('is-active');
        mainCategoriesArr[i].classList.remove('active');
      }

      subCategoriesArr[idx].classList.add('is-active');
      main.classList.add('active');
    })
  })
}

if (document.querySelector('.header__main-categories')) {
  const mainCategoriesEl = document.querySelector('.header__main-categories');
  const subCategoriesEl = document.querySelector('.header__subcategories');

  const mainCategoriesArr = mainCategoriesEl.querySelectorAll('.category-btn');
  const subCategoriesArr = subCategoriesEl.querySelectorAll('.header__categories-list');

  let lastClickedIndex = null;
  let preventDefaultUsed = false;

  mainCategoriesArr.forEach((main, idx) => {
    main.addEventListener('click', (e) => {
      if (lastClickedIndex !== idx) {
        preventDefaultUsed = false;
      }

      if (!preventDefaultUsed) {
        e.preventDefault();
        preventDefaultUsed = true;
      }

      lastClickedIndex = idx;

      for (let i = 0; i < subCategoriesArr.length; i++) {
        subCategoriesArr[i].classList.remove('is-active');
        mainCategoriesArr[i].classList.remove('is-active');
      }

      subCategoriesArr[idx].classList.add('is-active');
      main.classList.add('is-active');
    });
  });
}

if (document.querySelector('.menu__main-categories')) {
  const mainCategoriesEl = document.querySelector('.menu__main-categories');
  const subCategoriesEl = document.querySelector('.menu__subcategories');

  const mainCategoriesArr = mainCategoriesEl.querySelectorAll('.category-btn');
  const subCategoriesArr = subCategoriesEl.querySelectorAll('.menu__categories-list');

  let lastClickedIndex = null;
  let preventDefaultUsed = false;

  mainCategoriesArr.forEach((main, idx) => {
    main.addEventListener('click', (e) => {
      if (lastClickedIndex !== idx) {
        preventDefaultUsed = false;
      }

      if (!preventDefaultUsed) {
        e.preventDefault();
        preventDefaultUsed = true;
      }

      lastClickedIndex = idx;

      for (let i = 0; i < subCategoriesArr.length; i++) {
        subCategoriesArr[i].classList.remove('is-active');
        mainCategoriesArr[i].classList.remove('is-active');
      }

      subCategoriesArr[idx].classList.add('is-active');
      main.classList.add('is-active');
    });
  });
}
